// Country to flag emoji mapping
export const countryFlags = {
  'Afghanistan': '🇦🇫',
  'Albania': '🇦🇱',
  'Algeria': '🇩🇿',
  'Andorra': '🇦🇩',
  'Angola': '🇦🇴',
  'Antigua and Barbuda': '🇦🇬',
  'Argentina': '🇦🇷',
  'Armenia': '🇦🇲',
  'Australia': '🇦🇺',
  'Austria': '🇦🇹',
  'Azerbaijan': '🇦🇿',
  'Bahamas': '🇧🇸',
  'Bahrain': '🇧🇭',
  'Bangladesh': '🇧🇩',
  'Barbados': '🇧🇧',
  'Belarus': '🇧🇾',
  'Belgium': '🇧🇪',
  'Belize': '🇧🇿',
  'Benin': '🇧🇯',
  'Bermuda': '🇧🇲',
  'Bhutan': '🇧🇹',
  'Bolivia': '🇧🇴',
  'Bosnia and Herzegovina': '🇧🇦',
  'Botswana': '🇧🇼',
  'Brazil': '🇧🇷',
  'Brunei': '🇧🇳',
  'Bulgaria': '🇧🇬',
  'Burkina Faso': '🇧🇫',
  'Burundi': '🇧🇮',
  'Cambodia': '🇰🇭',
  'Cameroon': '🇨🇲',
  'Canada': '🇨🇦',
  'Cape Verde': '🇨🇻',
  'Central African Republic': '🇨🇫',
  'Chad': '🇹🇩',
  'Chile': '🇨🇱',
  'China': '🇨🇳',
  'Colombia': '🇨🇴',
  'Comoros': '🇰🇲',
  'Congo': '🇨🇬',
  'Costa Rica': '🇨🇷',
  'Croatia': '🇭🇷',
  'Cuba': '🇨🇺',
  'Cyprus': '🇨🇾',
  'Czech Republic': '🇨🇿',
  'Czechia': '🇨🇿',
  'Democratic Republic of the Congo': '🇨🇩',
  'Denmark': '🇩🇰',
  'Djibouti': '🇩🇯',
  'Dominica': '🇩🇲',
  'Dominican Republic': '🇩🇴',
  'East Timor': '🇹🇱',
  'Ecuador': '🇪🇨',
  'Egypt': '🇪🇬',
  'El Salvador': '🇸🇻',
  'Equatorial Guinea': '🇬🇶',
  'Eritrea': '🇪🇷',
  'Estonia': '🇪🇪',
  'Ethiopia': '🇪🇹',
  'Fiji': '🇫🇯',
  'Finland': '🇫🇮',
  'France': '🇫🇷',
  'Gabon': '🇬🇦',
  'Gambia': '🇬🇲',
  'Georgia': '🇬🇪',
  'Germany': '🇩🇪',
  'Ghana': '🇬🇭',
  'Gibraltar': '🇬🇮',
  'Greece': '🇬🇷',
  'Grenada': '🇬🇩',
  'Guatemala': '🇬🇹',
  'Guinea': '🇬🇳',
  'Guinea-Bissau': '🇬🇼',
  'Guyana': '🇬🇾',
  'Haiti': '🇭🇹',
  'Honduras': '🇭🇳',
  'Hong Kong': '🇭🇰',
  'Hungary': '🇭🇺',
  'Iceland': '🇮🇸',
  'India': '🇮🇳',
  'Indonesia': '🇮🇩',
  'Iran': '🇮🇷',
  'Iraq': '🇮🇶',
  'Ireland': '🇮🇪',
  'Israel': '🇮🇱',
  'Italy': '🇮🇹',
  'Jamaica': '🇯🇲',
  'Japan': '🇯🇵',
  'Jordan': '🇯🇴',
  'Kazakhstan': '🇰🇿',
  'Kenya': '🇰🇪',
  'Kiribati': '🇰🇮',
  'Kosovo': '🇽🇰',
  'Kuwait': '🇰🇼',
  'Kyrgyzstan': '🇰🇬',
  'Laos': '🇱🇦',
  'Latvia': '🇱🇻',
  'Lebanon': '🇱🇧',
  'Lesotho': '🇱🇸',
  'Liberia': '🇱🇷',
  'Libya': '🇱🇾',
  'Liechtenstein': '🇱🇮',
  'Lithuania': '🇱🇹',
  'Luxembourg': '🇱🇺',
  'Macao': '🇲🇴',
  'Madagascar': '🇲🇬',
  'Malawi': '🇲🇼',
  'Malaysia': '🇲🇾',
  'Maldives': '🇲🇻',
  'Mali': '🇲🇱',
  'Malta': '🇲🇹',
  'Marshall Islands': '🇲🇭',
  'Mauritania': '🇲🇷',
  'Mauritius': '🇲🇺',
  'Mexico': '🇲🇽',
  'Micronesia': '🇫🇲',
  'Moldova': '🇲🇩',
  'Monaco': '🇲🇨',
  'Mongolia': '🇲🇳',
  'Montenegro': '🇲🇪',
  'Morocco': '🇲🇦',
  'Mozambique': '🇲🇿',
  'Myanmar': '🇲🇲',
  'Namibia': '🇳🇦',
  'Nauru': '🇳🇷',
  'Nepal': '🇳🇵',
  'Netherlands': '🇳🇱',
  'New Zealand': '🇳🇿',
  'Nicaragua': '🇳🇮',
  'Niger': '🇳🇪',
  'Nigeria': '🇳🇬',
  'North Korea': '🇰🇵',
  'North Macedonia': '🇲🇰',
  'Norway': '🇳🇴',
  'Oman': '🇴🇲',
  'Pakistan': '🇵🇰',
  'Palau': '🇵🇼',
  'Palestine': '🇵🇸',
  'Panama': '🇵🇦',
  'Papua New Guinea': '🇵🇬',
  'Paraguay': '🇵🇾',
  'Peru': '🇵🇪',
  'Philippines': '🇵🇭',
  'Poland': '🇵🇱',
  'Portugal': '🇵🇹',
  'Qatar': '🇶🇦',
  'Romania': '🇷🇴',
  'Russia': '🇷🇺',
  'Rwanda': '🇷🇼',
  'Saint Kitts and Nevis': '🇰🇳',
  'Saint Lucia': '🇱🇨',
  'Saint Vincent and the Grenadines': '🇻🇨',
  'Samoa': '🇼🇸',
  'San Marino': '🇸🇲',
  'Sao Tome and Principe': '🇸🇹',
  'Saudi Arabia': '🇸🇦',
  'Senegal': '🇸🇳',
  'Serbia': '🇷🇸',
  'Seychelles': '🇸🇨',
  'Sierra Leone': '🇸🇱',
  'Singapore': '🇸🇬',
  'Slovakia': '🇸🇰',
  'Slovenia': '🇸🇮',
  'Solomon Islands': '🇸🇧',
  'Somalia': '🇸🇴',
  'South Africa': '🇿🇦',
  'South Korea': '🇰🇷',
  'South Sudan': '🇸🇸',
  'Spain': '🇪🇸',
  'Sri Lanka': '🇱🇰',
  'Sudan': '🇸🇩',
  'Suriname': '🇸🇷',
  'Sweden': '🇸🇪',
  'Switzerland': '🇨🇭',
  'Syria': '🇸🇾',
  'Taiwan': '🇹🇼',
  'Tajikistan': '🇹🇯',
  'Tanzania': '🇹🇿',
  'Thailand': '🇹🇭',
  'Timor-Leste': '🇹🇱',
  'Togo': '🇹🇬',
  'Tonga': '🇹🇴',
  'Trinidad and Tobago': '🇹🇹',
  'Tunisia': '🇹🇳',
  'Turkey': '🇹🇷',
  'Turkmenistan': '🇹🇲',
  'Tuvalu': '🇹🇻',
  'Uganda': '🇺🇬',
  'Ukraine': '🇺🇦',
  'United Arab Emirates': '🇦🇪',
  'United Kingdom': '🇬🇧',
  'United States': '🇺🇸',
  'Uruguay': '🇺🇾',
  'Uzbekistan': '🇺🇿',
  'Vanuatu': '🇻🇺',
  'Vatican City': '🇻🇦',
  'Venezuela': '🇻🇪',
  'Vietnam': '🇻🇳',
  'Yemen': '🇾🇪',
  'Zambia': '🇿🇲',
  'Zimbabwe': '🇿🇼'
};

// Function to get flag emoji for a country
export const getCountryFlag = (countryName) => {
  return countryFlags[countryName] || '🌍';
};
